import { useState } from "react";
import { Flag, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/services/api";

const MOTIFS = [
  { value: "absence",      label: "Absence",      desc: "N'est pas venu sans prevenir" },
  { value: "comportement", label: "Comportement", desc: "Insultes, agressivite, antijeu" },
  { value: "tricherie",    label: "Tricherie",    desc: "Faux compte, score truque, etc." },
];

export default function ReportPlayerModal({ targetUser, onClose }) {
  const [motif, setMotif] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!motif) return toast.error("Choisis un motif");
    setSubmitting(true);
    try {
      await api.createReport(targetUser.id, motif, message);
      toast.success("Signalement envoye aux moderateurs");
      onClose();
    } catch (err) {
      toast.error(err.message || "Echec du signalement");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      data-testid="report-modal"
      onClick={onClose}
      style={{
        position: "fixed", inset: 0,
        backgroundColor: "rgba(0,0,0,0.85)", zIndex: 10001,
        display: "flex", alignItems: "flex-end", justifyContent: "center",
      }}
    >
      <div onClick={(e) => e.stopPropagation()} style={{
        backgroundColor: "#0a0a0a",
        borderTopLeftRadius: "20px", borderTopRightRadius: "20px",
        padding: "20px", width: "100%", maxWidth: "440px",
        border: "1px solid #1a1a1a",
        animation: "slideUp 0.25s ease-out",
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Flag size={18} color="#ef4444" />
            <h3 style={{ fontSize: "16px", fontWeight: 800, color: "#fff" }}>
              Signaler {targetUser.name}
            </h3>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#6b7280", cursor: "pointer" }}>
            <X size={18} />
          </button>
        </div>

        <p style={{ fontSize: "12px", color: "#9ca3af", marginBottom: "14px", lineHeight: 1.5 }}>
          Ton signalement sera envoye aux moderateurs. Aucune notification n'est faite au joueur signale.
        </p>

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            {MOTIFS.map(m => {
              const selected = motif === m.value;
              return (
                <button
                  key={m.value}
                  type="button"
                  data-testid={`report-motif-${m.value}`}
                  onClick={() => setMotif(m.value)}
                  style={{
                    minHeight: "56px",
                    padding: "10px 14px",
                    borderRadius: "12px",
                    backgroundColor: selected ? "rgba(239,68,68,0.1)" : "#0f0f0f",
                    border: selected ? "1.5px solid #ef4444" : "1px solid #222",
                    color: selected ? "#fca5a5" : "#d1d5db",
                    cursor: "pointer", textAlign: "left",
                    fontFamily: "inherit", touchAction: "manipulation",
                  }}
                >
                  <div style={{ fontSize: "14px", fontWeight: 700 }}>{m.label}</div>
                  <div style={{ fontSize: "11px", color: "#9ca3af", marginTop: "2px" }}>{m.desc}</div>
                </button>
              );
            })}
          </div>

          <textarea
            data-testid="report-message-input"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Decris (optionnel)"
            maxLength={500}
            rows={3}
            style={{
              width: "100%", padding: "10px 12px", borderRadius: "10px",
              backgroundColor: "#000", border: "1px solid #333",
              color: "#fff", fontSize: "14px", resize: "none", fontFamily: "inherit",
            }}
          />

          <button
            type="submit"
            data-testid="report-submit-btn"
            disabled={submitting || !motif}
            style={{
              minHeight: "50px", borderRadius: "12px",
              background: !motif ? "#1a1a1a" : "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
              border: "none", color: "#fff", fontSize: "14px", fontWeight: 800,
              cursor: !motif ? "not-allowed" : "pointer",
              display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
            }}
          >
            {submitting ? <Loader2 size={16} className="animate-spin" /> : <Flag size={16} />}
            Envoyer le signalement
          </button>
        </form>
      </div>
    </div>
  );
}
